<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
    :style="{ color }"
  >
    <path
      d="M3.18367 14.9906H7.75927V13.8431H3.18367V14.9906ZM3.09905 9.9915H10.6404V8.84187H3.09905V9.98937V9.9915ZM3.18367 12.4916H9.13851V11.343H3.18367V12.4905V12.4916ZM11.8335 16.0191L9.2887 16.6991C9.1713 16.7306 9.04772 16.7307 8.93026 16.6994C8.8128 16.6681 8.70555 16.6064 8.61918 16.5206C8.5333 16.4354 8.4715 16.3288 8.44009 16.2118C8.40869 16.0947 8.4088 15.9714 8.44043 15.8544L9.1311 13.2927C9.14669 13.1376 9.21461 12.9925 9.3236 12.8815L13.4053 8.82275V6.311H8.5462L8.5335 1.5H0V18.5H13.4053V14.6994L12.2778 15.8204C12.1588 15.9392 12.0009 16.0106 11.8335 16.0212V16.0191Z"
    ></path>
    <path
      d="M10.5177 15.1393L10.0079 14.6314L10.2343 13.7878L11.366 14.9141L10.5177 15.1393ZM18.0253 5.20175L13.4053 9.79706L9.81332 13.3692L9.82389 13.3798L9.10995 16.0329L11.7775 15.321L11.788 15.3316L13.4053 13.7241L20 7.16525L18.0253 5.20175ZM9.39658 1.5V5.46525H13.3841C13.438 5.41 9.39553 1.5 9.39553 1.5"
    ></path>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';

export default {
  name: 'QuoteSVG',
  props: {
    size: VueTypes.number.isRequired,
    color: VueTypes.string.isRequired,
  },
};
</script>

<style></style>
